import { Accept } from '@/ui/DropArea';

/** The picker and drops both accept only this. Anything else arrives as a rejection. */
export const ASSIGNMENT_FILE_ACCEPT: Accept = { 'application/pdf': ['.pdf'] };

export const ASSIGNMENT_FILE_MAX_SIZE_BYTES = 200 * 1024 * 1024;

export const ASSIGNMENT_FILE_ERROR_MESSAGE = {
  notPdf: 'This file is not a PDF file. Upload a PDF file to continue.',
  tooLarge: 'File is too large. Maximum size 200MB.',
  uploadFailed: 'Something went wrong while uploading your file. Please try again later.',
} as const;
